<template>
    <div class="eml-searchbar">
        <div class="row">
            <div class="eml-bar-wrap">
                <div
                    class="eml-searchbar-close"
                    @click="
                        search_term.text = '';
                        emails_set_query('');
                    "
                >
                    <o-icon
                        icon="close"
                        size="is-small"
                        pack="fas"
                        v-show="!!search_term.text"
                    />
                </div>
                <o-autocomplete
                    field="subject"
                    icon="search"
                    icon-pack="fa"
                    icon-right="delete-left"

                    placeholder="Search"
                    ref="autocomplete"
                    type="search"
                    v-model="search_term.text"
                    :clear-on-select="false"
                    :custom-formatter="get_option"
                    :data="suggestions"
                    :loading="is_loading"
                    @blur="is_active = false"
                    @focus="is_active = true"
                    @keydown.native.tab="onTabHandler"
                    @keyup.native.enter.prevent="onEnterHandler"
                    @select="handle_select"
                    @typing="fetch_suggestions"
                    @update:modelValue="clear($event)"
                >
                    <template #default="{ option }">
                        <div
                            class="eml-sb-msg-container contact"
                            v-if="
                                ['contact', 'ordino_contact'].includes(
                                    option.type
                                )
                            "
                        >
                            <div class="eml-so-icon">
                                <img :src="get_photo_url(option)" />
                            </div>
                            <div class="eml-sb-content contact">
                                <div class="eml-title">
                                    {{
                                        (option.type === "contact" &&
                                            option.name) ||
                                        option.full_name
                                    }}
                                </div>
                                <div class="eml-subtitle">
                                    {{ option.email }}
                                </div>
                            </div>
                        </div>
                        <div
                            class="eml-sb-msg-container"
                            v-else-if="option.type === 'message'"
                        >
                            <div class="eml-so-icon">
                                <o-icon icon="envelope" size="is-small" />
                            </div>
                            <div class="eml-sb-content eml-type-message">
                                <div class="eml-snippet">
                                    {{ option.subject }}
                                </div>
                                <small>
                                    {{ option.thread_from }}
                                    &nbsp;<span class="count">{{
                                        option.from_names_count
                                    }}</span>
                                </small>
                            </div>
                            <div class="eml-sb-content-right">
                                <small>{{ get_date(option.date) }}</small>
                            </div>
                        </div>
                        <div
                            class="eml-sb-msg-container"
                            v-else-if="option.type === 'search-term'"
                        >
                            <div class="eml-so-icon">
                                <o-icon icon="search" size="is-small" pack="fas" />
                            </div>
                            <div class="eml-sb-content">
                                More search results for "{{
                                    option.text
                                }}"
                            </div>
                            <div class="eml-sb-content-right">
                                <small>Press ENTER</small>
                            </div>
                        </div>
                    </template>
                </o-autocomplete>
                <input class="eml-shadow-text" disabled v-model="shadow_text" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import {
    autocomplete_contacts,
    autocomplete_ordino_contacts,
    fetchMessages,
    get_thread_summary,
} from '../gmail_api'

import { get_date } from '../utils'

export default {
    computed: {
        ...mapGetters([
            'emails_query',
        ]),
        ordino_contacts() {
            return this.data.ordino_contacts.filter(ordino_contact => (ordino_contact.type = 'ordino_contact', !this.data.contacts.some(c => c.email === ordino_contact.email)))
        },
        suggestions() {
            const suggestions_array = [...this.data.contacts, ...this.ordino_contacts, ...this.data.messages]
            if (!!this.search_term.text && this.search_term.text.length) {
                suggestions_array.push(this.search_term)
            }
            return suggestions_array
        },
    },
    data() {
        return {
            data: {
                contacts: [],
                messages: [],
                ordino_contacts: [],
            },
            is_active: false,
            is_loading: false,
            messages_count: 5,
            search_term: {
                text: '',
                type: 'search-term',
            },
            shadow_text: '',
        }
    },
    methods: {
        ...mapActions([
            'emails_set_query',
        ]),
        fetch() {
            this.emails_set_query(this.get_query())
            this.$emit('fetch', this.get_query())
            this.$router.push({ name: "emails", params: { label: 'INBOX' } })
        },
        clear(search_term){
            if(search_term === "") {
              this.fetch()
            }
          },
        fetch_suggestions: _.debounce(function (q) {
            if (!q || q.length < 2) {
                this.data.messages = []
                return
            }
            const labelIds = []
            let params = {
                includeSpamTrash: false,
                labelIds,
                maxResults: this.messages_count,
                q,
                userId: "me",
            }

            this.data.contacts = []
            // autocomplete_contacts(q.trim()).then(response => {
            //     this.data.contacts = response
            // })
            autocomplete_ordino_contacts(q.trim()).then(response => {
                this.data.ordino_contacts = response
            })
            this.data.messages = []
            fetchMessages(params).then(res => {
                const { messages } = res
                !!messages && messages.forEach(m => {
                    const get_thread_params = {
                        format: 'metadata',
                        id: m.id,
                        userId: 'me',
                    }
                    get_thread_summary(get_thread_params).then(thread => {
                        if (thread.messages.length) {
                            const { from, from_names_count } = thread
                            const message = { ...thread.messages[0], thread_from: from, from_names_count }
                            message.type = 'message'
                            this.data.messages.push(message)
                        }
                    })
                });
                return res
            })
        }, 250),
        get_date,
        get_option(option) {
            if (typeof option === 'string') {
                return option
            }
            switch (option.type) {
                case 'contact':
                case 'ordino_contact':
                    return option.email
                case 'message':
                    return option.subject
                case 'search-term':
                    return option.text
            }
            return ''
        },
        get_photo_url(option) {
            return option.type === 'contact' && option.photoUrl || option.avatar_url
        },
        get_query() {
            return this.search_term.text
        },
        handle_select(option) {
            if (!option) {
                return
            }
            this.search_term.text = this.get_option(option)
            switch (option.type) {
                case 'contact':
                    this.fetch()
                    break
                case 'message':
                    this.$router.push({ name: "emails.view", params: { message_id: option.message_id } })
                    break
                case 'search-term':
                    this.fetch()
                    break
                default:
                    break
            }
        },
        onEnterHandler() {
            this.$refs.autocomplete.setSelected(this.search_term, false)
            this.$refs.autocomplete.isActive = false
        },
        onTabHandler(e) {
            const stl = this.search_term.text.length, shtl = this.shadow_text.length
            if (stl && shtl > stl) {
                this.search_term.text = this.shadow_text
                e.preventDefault()
            }
        },
    },
    mounted() {
        this.search_term.text = this.emails_query
    },
    watch: {
        'search_term.text'() {
            const text = (this.search_term.text || '').trim()
            if (text === '') {
                this.shadow_text = ''
                return
            }
            if (!(this.shadow_text.indexOf(text) === 0)) {
                this.shadow_text = ''
            }
            this.emails_set_query(this.get_query())
        },
        suggestions(value) {
            const search_text = (this.search_term.text || '').trim()
            if (search_text === '') {
                this.shadow_text = ''
                return
            }
            if (this.suggestions.length > 1) {
                const text = (this.get_option(this.suggestions[1]) || '').trim()
                if (text.indexOf(search_text) === 0) {
                    this.shadow_text = text
                } else {
                    this.shadow_text = ''
                }
            }
        }
    },
}
</script>

<style lang="sass">
.eml-searchbar
  .eml-bar-wrap
    //position: relative
    &:hover, &:active
      .autocomplete.control > .control > input[type=text], > .icon
        z-index: 2
      .eml-searchbar-close
        z-index: 3
    .autocomplete.control
      > .control
        > input[type=text]
          background: transparent
        > input[type=text], > .icon
          z-index: 1
      > .dropdown-menu
        .dropdown-content
          max-height: 100%
          padding-left: 0
          a.dropdown-item
            &:hover,&.is-hovered
              border-left: 1px solid #019ae0
    .eml-searchbar-close
      color: #dbdbdb
      position: absolute
      right: 7px
      top: 6px
      &.active
        color: #4a4a4a
    .eml-shadow-text
      background: white
      border: none
      color: silver
      font-size: 1rem
      line-height: 32px
      outline-color: transparent
      padding-left: 37px
      position: absolute
      top: 1px
      width: 100%
      z-index: 0
    .dropdown-item
      .eml-sb-msg-container
        display: flex
        &.contact
          align-items: center
        .eml-sb-icon
          align-items: center
          display: flex
          flex-shrink: 0
          width: 43px
        .eml-sb-content
          flex: 1
          &.contact
            margin-left: 10px
          &.eml-type-message
            max-width: 90%
            .eml-snippet
              display: block
              max-width: 80%
              overflow: hidden
              text-overflow: ellipsis
        .eml-sb-content-right
          width: 40px
</style>